// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1qkKC","background":"App_background__1jvZ4"};